/* unplugin-vue-components disabled */import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=79cde079&lang=stylus"

const __exports__ = script;

export default __exports__